/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const NftType = {
    INDUSTRY_PASS: 'INDUSTRY_PASS',
    INFINITE_ACCESS: 'INFINITE_ACCESS',
    LOOTBOX: 'LOOTBOX',
    XP_MULTIPLIER: 'XP_MULTIPLIER',
    BRAND_MAP_AUTOMINT: 'BRAND_MAP_AUTOMINT',
    GUILD_BADGE_AUTOMINT: 'GUILD_BADGE_AUTOMINT',
    OVERWOLF_QUEST_REWARD: 'OVERWOLF_QUEST_REWARD',
    GUILD_QUEST_REWARD: 'GUILD_QUEST_REWARD',
    BRAND_CHALLENGE_REWARD: 'BRAND_CHALLENGE_REWARD',
    BRAND_CHALLENGE_RAFFLE_PRIZE: 'BRAND_CHALLENGE_RAFFLE_PRIZE',
    LOOTBOX_REDEEM_REWARD: 'LOOTBOX_REDEEM_REWARD',
    GUILD_SPONSORED_COMPETITION_REWARD: 'GUILD_SPONSORED_COMPETITION_REWARD'
} as const;
export type NftType = typeof NftType[keyof typeof NftType];


export function instanceOfNftType(value: any): boolean {
    for (const key in NftType) {
        if (Object.prototype.hasOwnProperty.call(NftType, key)) {
            if (NftType[key as keyof typeof NftType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NftTypeFromJSON(json: any): NftType {
    return NftTypeFromJSONTyped(json, false);
}

export function NftTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): NftType {
    return json as NftType;
}

export function NftTypeToJSON(value?: NftType | null): any {
    return value as any;
}

export function NftTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): NftType {
    return value as NftType;
}

